import { render } from "./MisCursos.vue?vue&type=template&id=71bc14cf"
import script from "./MisCursos.vue?vue&type=script&lang=js"
export * from "./MisCursos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__